module.exports = __webpack_public_path__ + "img/kr-product-content3-img-2.7748815.png";